













































































































import { Component, Prop, Watch } from "vue-property-decorator";
import _ from "lodash";

import AppVue from "@/AppVue.vue";
import { QuestionnaireLookups, QuestionnaireModel, CapabilityRatingItemModel } from "@/core/models";
import { InputTextareaCpt } from "@/core/components";
import { CapabilityRatingsCpt, SkillAmountsCpt, StrategyGridCpt } from ".";

@Component({
  components: {
    CapabilityRatingsCpt,
    SkillAmountsCpt,
    StrategyGridCpt,
    InputTextareaCpt,
  },
})
export default class QuestionnaireStep3Cpt extends AppVue {
  @Prop() lookups: QuestionnaireLookups;
  @Prop() model: QuestionnaireModel;
  @Prop({ default: false }) disabled: boolean;

  created() {
    this.syncCapabilities();
  }

  @Watch("model.activeStep")
  private onStepChange() {
    this.syncCapabilities();
  }

  get criticalSkill() {
    return this.model.criticalSkills[this.model.subStep];
  }

  get cs() {
    return `Critical Skill #${this.model.subStep + 1} (${this.criticalSkill.name})`;
  }

  private syncCapabilities() {
    if (this.model.subStep < 0 || this.model.subStep > this.model.criticalSkills.length - 1) {
      return;
    }

    const capabilities: CapabilityRatingItemModel[] = [];

    for (let i = 0; i < 4; i++) {
      const identifier = `strategicCapability${i + 1}`;
      const text = (this.model as any)[identifier];
      const capability = new CapabilityRatingItemModel({
        identifier,
        text,
        isSelected: false,
      });

      const existingCapability = _.find(this.criticalSkill.capabilities, { identifier });
      if (existingCapability && existingCapability.text === text) {
        capability.id = existingCapability.id;
        capability.isSelected = existingCapability.isSelected;
        capability.sortOrder = existingCapability.sortOrder;
      }

      capabilities.push(capability);
    }

    this.criticalSkill.capabilities = _.filter(capabilities, capability => !!capability.text);
  }
}
